import React from 'react';

const Search: React.FC<IconProps> = ({
    height,
    width,
    fillColor,
}) => {
    const h = height ?? 16;
    const w = width ?? 16;
    const fill = fillColor ?? "#454648";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M7.33398 1.3335C4.02028 1.3335 1.33398 4.01979 1.33398 7.3335C1.33398 10.6472 4.02028 13.3335 7.33398 13.3335C8.75066 13.3335 10.0527 12.8425 11.0791 12.0214L13.5292 14.4716C13.7896 14.7319 14.2117 14.7319 14.4721 14.4716C14.7324 14.2112 14.7324 13.7891 14.4721 13.5288L12.0219 11.0786C12.843 10.0522 13.334 8.75017 13.334 7.3335C13.334 4.01979 10.6477 1.3335 7.33398 1.3335ZM2.66732 7.3335C2.66732 4.75617 4.75666 2.66683 7.33398 2.66683C9.91131 2.66683 12.0007 4.75617 12.0007 7.3335C12.0007 9.91082 9.91131 12.0002 7.33398 12.0002C4.75666 12.0002 2.66732 9.91082 2.66732 7.3335Z" fill={fill}/>
        </svg>
    );
};

export default Search;